import classNames from "classnames";
import React from "react";

import style from "./status-label.scss";
import { HighlightedLabel } from "components/highlighted-label/HighlightedLabel";

export enum Status {
    ERROR = "ERROR",
    SUCCESS = "SUCCESS",
    WARNING = "WARNING",
    NEUTRAL = "NEUTRAL",
    INFO = "INFO",
}

interface Props {
    status: Status;
    children: React.ReactNode;
    className?: string;
    testId?: string;
    dataType?: string;
}

export const STATUS_TO_CLASSNAME = new Map([
    [Status.ERROR, style.statusFailed],
    [Status.SUCCESS, style.statusSuccessful],
    [Status.WARNING, style.statusWarning],
    [Status.NEUTRAL, style.statusNeutral],
    [Status.INFO, style.statusInfo],
]);

export const getClassName = (status: Status): string => {
    return STATUS_TO_CLASSNAME.get(status) || style.statusNeutral;
};

export const StatusLabel = (props: Props) => {
    return (
        <HighlightedLabel
            testId={props.testId}
            dataType={props.dataType}
            className={classNames(style.statusBadge, getClassName(props.status), props.className)}
        >
            {props.children}
        </HighlightedLabel>
    );
};
